import React from 'react';
import 'twin.macro';
import { useFichesDePrepTrash } from '@teetsh/app/src/containers/UserSettings/Trash/FichesDePrep/useFichesDePrepTrash';
import { useRestoreFicheDePrep } from '@teetsh/app/src/containers/UserSettings/Trash/FichesDePrep/useRestoreFicheDePrep';
import { RestorableList } from '@teetsh/app/src/containers/UserSettings/Trash/components/RestorableList';
import { RestorableFicheDePrep } from '@teetsh/app/src/types/sequences';

function Details({ cycle, sequenceName }: RestorableFicheDePrep) {
  return (
    <div tw="font-light">
      {cycle && <div tw="first-letter:capitalize">{cycle}</div>}
      <div tw="first-letter:capitalize">{sequenceName}</div>
    </div>
  );
}

export function FichesDePrepRestorableList() {
  const { data = [] } = useFichesDePrepTrash();
  const restore = useRestoreFicheDePrep();

  return (
    <RestorableList<RestorableFicheDePrep>
      items={data}
      restore={restore}
      cardFileDetails={Details}
      tableFileDetails={({ row }) => Details(row.original)}
    />
  );
}
